import { ref } from 'vue'
import request from '@/utils/request'
import type { AcsResult } from '@/api/types'

const platformName = ref('')
const logoUrl = ref('')

function applyBrand(data: Record<string, unknown>) {
  if (data.platformName) platformName.value = String(data.platformName)
  if (data.logoUrl) logoUrl.value = String(data.logoUrl)
}

async function initPlatformBrand() {
  // 先从 localStorage 读（秒级，无网络等待）
  const local = localStorage.getItem('admin.platform.defaults')
  if (local) {
    try { applyBrand(JSON.parse(local)) } catch { /* ignore */ }
  }
  // 再从后端公开接口拉取最新值
  try {
    const res = await request<AcsResult<Record<string, unknown>>>({
      url: '/system/config/getLogo',
      method: 'get',
    })
    const data = (res?.data ?? {}) as Record<string, unknown>
    applyBrand(data)
    if (Object.keys(data).length) {
      localStorage.setItem('admin.platform.defaults', JSON.stringify(data))
    }
  } catch { /* ignore */ }
}

export function usePlatformBrand() {
  return { platformName, logoUrl, initPlatformBrand }
}
